var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['form-title', _vm.required ? 'form-title__required' : '']},[_vm._t("prefixIcon"),_vm._t("default"),_vm._t("suffixIcon")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }